import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {ServiceService} from "../services/service.service";
import {Services} from "../models/services";

@Injectable()
export class ServicesResolve implements Resolve<Services> {
    constructor(private serviceService: ServiceService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<Services> {
        return this.serviceService.getAll();
    }
}
